import React from 'react';
import { useSelector } from 'react-redux';
import {
  AppContent,
  ErrorBoundary,
  Author,
} from 'mm-ui-components';
import { Store } from 'redux';
import { Theme } from '../../components/connectedComponents/Theme';
import { MetaTags } from '../../components/connectedComponents/MetaTags';
import { HeadScripts } from '../../components/connectedComponents/HeadScripts';
import { Page } from '../Page';
import { HeaderConnected } from '../../components/connectedComponents/HeaderConnected';
import { FooterConnected } from '../../components/connectedComponents/FooterConnected';
import { MainWrapperConnected } from '../../components/connectedComponents/MainWrapperConnected';
import { AppState, AppActions } from '../../store/initialStateRegistration';
import { ErrorReporter } from '../../errorReporting/errorReporter.type';
import { getImage, getName, getSocial, getDescription, getJoinDateText, getJoinDate, getArticlesNumberText, getTotalArticles, getFeed, getArticles, getLoadMoreNext, getLoadMoreText } from '../../store/template/authorPage/authorPage.selectors';
import {
  LoadMoreButton, useFetchNextPosts,
} from '../../components/connectedComponents/LoadMoreButton';
import { SECTION_NAMES } from '../templates.const';
import { getSecondaryHeader } from '../../store/secondaryHeader/secondaryHeader.selectors';
import { useMeasureHydrateTime } from '../useMeasureHydrateTime';

interface AuthorPageProps {
  store: Store<AppState, AppActions>;
  errorProvider: ErrorReporter;
}

export const AuthorPageComponent: React.FunctionComponent<AuthorPageProps> = ({ store, errorProvider }) => {
  useMeasureHydrateTime();
  return (
    <Page store={store} errorProvider={errorProvider}>
      <ErrorBoundary>
        <AuthorPageContentConnected />
      </ErrorBoundary>
    </Page>
  );
};

export const AuthorPageContentConnected: React.FunctionComponent = () => {
  const image = useSelector(getImage);
  const name = useSelector(getName);
  const social = useSelector(getSocial);
  const description = useSelector(getDescription);
  const joinDateText = useSelector(getJoinDateText);
  const joinDate = useSelector(getJoinDate);
  const articlesNumberText = useSelector(getArticlesNumberText);
  const totalArticles = useSelector(getTotalArticles);
  const feed = useSelector(getFeed);
  const articles = useSelector(getArticles);
  const isSecondaryHeaderEnabled = !!useSelector(getSecondaryHeader);

  return (
    <React.Fragment>
      <MetaTags />
      <HeadScripts />
      <Theme>
        <AppContent>
          <HeaderConnected />
          <MainWrapperConnected>
            <Author {...{ image, name, social, description, joinDateText, joinDate, articlesNumberText, totalArticles, feed, articles, isSecondaryHeaderEnabled }} />
            <LoadMoreAuthorPostsButtonConnected />
          </MainWrapperConnected>
          <FooterConnected />
        </AppContent>
      </Theme>
    </React.Fragment>
  );
};


export const LoadMoreAuthorPostsButtonConnected: React.FunctionComponent = () => {
  const sectionKey = SECTION_NAMES.AUTHOR_SECTION;
  const shouldDisplay = !!useSelector(getLoadMoreNext(sectionKey));
  const text = useSelector(getLoadMoreText);
  const onClick = useFetchNextPosts(sectionKey, getLoadMoreNext);
  return <LoadMoreButton {...{ onClick, shouldDisplay, text }} />;
};
